export const AUTH_BODY_TRANSLATIONS :Record<string, { default: string; withSecurity: string }> = {
  en: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_GB: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_US: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_AE: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_AU: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_CA: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_GH: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_IE: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_IN: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_JM: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_MY: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_NZ: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_QA: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_SG: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_UG: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  en_ZA: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },
  
  af: { default: "{{1}} is jou verifikasiekode.", withSecurity: "{{1}} is jou verifikasiekode. Moenie hierdie kode deel nie, vir jou eie sekuriteit." },
  sq: { default: "{{1}} është kodi yt i verifikimit.", withSecurity: "{{1}} është kodi yt i verifikimit. Për sigurinë tënde, mos e ndaj këtë kod." },

  ar: { default: "‏{{1}}‏ هو كود التحقق الخاص بك.", withSecurity: "‏{{1}}‏ هو كود التحقق الخاص بك. للحفاظ على أمانك، لا تشارك هذا الكود مع أي شخص." },
  ar_EG: { default: "‏{{1}}‏ هو كود التحقق الخاص بك.", withSecurity: "‏{{1}}‏ هو كود التحقق الخاص بك. للحفاظ على أمانك، لا تشارك هذا الكود مع أي شخص." },
  ar_AE: { default: "‏{{1}}‏ هو كود التحقق الخاص بك.", withSecurity: "‏{{1}}‏ هو كود التحقق الخاص بك. للحفاظ على أمانك، لا تشارك هذا الكود مع أي شخص." },
  ar_LB: { default: "‏{{1}}‏ هو كود التحقق الخاص بك.", withSecurity: "‏{{1}}‏ هو كود التحقق الخاص بك. للحفاظ على أمانك، لا تشارك هذا الكود مع أي شخص." },
  ar_MA: { default: "‏{{1}}‏ هو كود التحقق الخاص بك.", withSecurity: "‏{{1}}‏ هو كود التحقق الخاص بك. للحفاظ على أمانك، لا تشارك هذا الكود مع أي شخص." },
  ar_QA: { default: "‏{{1}}‏ هو كود التحقق الخاص بك.", withSecurity: "‏{{1}}‏ هو كود التحقق الخاص بك. للحفاظ على أمانك، لا تشارك هذا الكود مع أي شخص." },

  az: { default: "{{1}} sizin təsdiqləmə kodunuzdur.", withSecurity: "{{1}} sizin təsdiqləmə kodunuzdur. Təhlükəsizliyiniz üçün bu kodu paylaşmayın." },
  be_BY: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },

  bn: { default: "আপনার যাচাইকরণের কোড {{1}}", withSecurity: "আপনার যাচাইকরণের কোড {{1}}। আপনার নিরাপত্তার জন্য এই কোড শেয়ার করবেন না।" },
  bn_IN: { default: "আপনার যাচাইকরণের কোড {{1}}", withSecurity: "আপনার যাচাইকরণের কোড {{1}}। আপনার নিরাপত্তার জন্য এই কোড শেয়ার করবেন না।" },

  bg: { default: "{{1}} е вашият код за потвърждение.", withSecurity: "{{1}} е вашият код за потвърждение. С оглед на сигурността ви не споделяйте този код." },
  ca: { default: "{{1}} és el teu codi de verificació.", withSecurity: "{{1}} és el teu codi de verificació. Per seguretat, no el comparteixis." },

  zh_CN: { default: "{{1}} 是你的验证码。", withSecurity: "{{1}} 是你的验证码。为安全起见，请不要分享这组验证码。" },
  zh_HK: { default: "{{1}} 是您的驗證碼。", withSecurity: "{{1}} 是你的驗證碼。為安全起見，請勿分享此驗證碼。" },
  zh_TW: { default: "{{1}} 是你的驗證碼。", withSecurity: "{{1}} 是你的驗證碼。為了安全起見，請勿分享此驗證碼。" },

  hr: { default: "{{1}} je vaš kôd za provjeru valjanosti.", withSecurity: "{{1}} je vaš kôd za provjeru valjanosti. Nemojte dijeliti kôd radi svoje sigurnosti." },
  cs: { default: "Váš ověřovací kód je {{1}}.", withSecurity: "" },
  da: { default: "", withSecurity: "Váš ověřovací kód je {{1}}. Z bezpečnostních důvodů kód s nikým nesdílejte." },

  prs_AF: { default: "{{1}} is your verification code.", withSecurity: "{{1}} is your verification code. For your security, do not share this code." },

  nl: { default: "{{1}} is uw verificatiecode.", withSecurity: "{{1}} is uw verificatiecode. Deel deze code om veiligheidsredenen niet." },
  nl_BE: { default: "", withSecurity: "" },

  et: { default: "{{1}} on sinu kinnituskood.", withSecurity: "{{1}} on sinu kinnituskood. Turvalisuse huvides ära jaga seda koodi." },
  fil: { default: "{{1}} ang iyong verification code.", withSecurity: "{{1}} ang iyong verification code. Para sa iyong seguridad, huwag i-share ang code na ito." },
  fi: { default: "{{1}} on vahvistuskoodisi.", withSecurity: "{{1}} on vahvistuskoodisi. Pidä koodi omana tietonasi turvallisuussyistä." },

  fr: { default: "Votre code de vérification est {{1}}.", withSecurity: "Votre code de vérification est {{1}}. Pour votre sécurité, ne le partagez pas." },
  fr_BE: { default: "Votre code de vérification est {{1}}.", withSecurity: "Votre code de vérification est {{1}}. Pour votre sécurité, ne le partagez pas." },
  fr_CA: { default: "Votre code de vérification est {{1}}.", withSecurity: "Votre code de vérification est {{1}}. Pour votre sécurité, ne le partagez pas." },
  fr_CH: { default: "Votre code de vérification est {{1}}.", withSecurity: "Votre code de vérification est {{1}}. Pour votre sécurité, ne le partagez pas." },
  fr_CI: { default: "Votre code de vérification est {{1}}.", withSecurity: "Votre code de vérification est {{1}}. Pour votre sécurité, ne le partagez pas." },
  fr_MA: { default: "Votre code de vérification est {{1}}.", withSecurity: "Votre code de vérification est {{1}}. Pour votre sécurité, ne le partagez pas." },

  ka: { default: "{{1}} არის თქვენი დამადასტურებელი კოდი.", withSecurity: "{{1}} არის თქვენი დამადასტურებელი კოდი. თქვენივე უსაფრთხოებისთვის, არავის გაუზიაროთ ეს კოდი." },

  de: { default: "Dein Verifizierungscode lautet {{1}}.", withSecurity: "Dein Verifizierungscode lautet {{1}}. Aus Sicherheitsgründen solltest du den Code nicht teilen." },
  de_AT: { default: "Dein Verifizierungscode lautet {{1}}.", withSecurity: "Dein Verifizierungscode lautet {{1}}. Aus Sicherheitsgründen solltest du den Code nicht teilen." },
  de_CH: { default: "Dein Verifizierungscode lautet {{1}}.", withSecurity: "Dein Verifizierungscode lautet {{1}}. Aus Sicherheitsgründen solltest du den Code nicht teilen." },

  el: { default: "Το {{1}} είναι ο κωδικός επαλήθευσής σας.", withSecurity: "Το {{1}} είναι ο κωδικός επαλήθευσης. Για τη δική σας ασφάλεια, μην τον κοινοποιήσετε σε τρίτους." },

  gu: { default: "{{1}}એ તમારો ખાતરીનો કોડ છે.", withSecurity: "{{1}}એ તમારો ખાતરીનો કોડ છે. તમારી સુરક્ષા માટે, આ કોડ કોઈની સાથે શેર કરશો નહિ." },

  ha: { default: "{{1}} ita ce lambar sirrinka ta tantancewa.", withSecurity: "{{1}} ita ce lambar sirrinka ta tantancewa. Saboda tsaro, kar ka yaɗa wannan lambar sirrin." },

  he: { default: "קוד האימות הוא ‏{{1}}‏.", withSecurity: "‏{{1}}‏ הוא קוד האימות שלך. מטעמי אבטחה, אין לשתף את הקוד הזה." },

  hi: { default: "{{1}} आपका वेरिफ़िकेशन कोड है.", withSecurity: "{{1}} आपका वेरिफ़िकेशन कोड है. अपनी सुरक्षा के लिए, इस कोड को किसी के साथ शेयर न करें." },

  hu: { default: "A(z) {{1}} az ellenőrző kódod.", withSecurity: "A(z) {{1}} az ellenőrző kódod. A saját biztonságod érdekében mással ne oszd meg ezt a kódot." },

  id: { default: "{{1}} adalah kode verifikasi Anda.", withSecurity: "{{1}} adalah kode verifikasi Anda. Demi keamanan, jangan bagikan kode ini." },

  ga: { default: "Is é {{1}} do chód fíoraithe.", withSecurity: "Is é {{1}} do chód fíoraithe. Ar mhaithe le do shlándáil, ná comhroinn an cód." },

  it: { default: "{{1}} è il tuo codice di verifica.", withSecurity: "{{1}} è il tuo codice di verifica. Per garantire la tua sicurezza, ti consigliamo di non condividere questo codice." },

  ja: { default: "{{1}}があなたの認証コードです。", withSecurity: "{{1}}があなたの認証コードです。セキュリティのため、このコードは他の人に共有しないでください。" },

  kn: { default: "{{1}} ಇದು ನಿಮ್ಮ ಪರಿಶೀಲನೆ ಕೋಡ್ ಆಗಿದೆ.", withSecurity: "{{1}} ನಿಮ್ಮ ಪರಿಶೀಲನೆ ಕೋಡ್ ಆಗಿದೆ. ನಿಮ್ಮ ಭದ್ರತೆಗಾಗಿ, ಈ ಕೋಡ್ ಅನ್ನು ಹಂಚಿಕೊಳ್ಳಬೇಡಿ." },

  kk: { default: "{{1}} ಇದು ನಿಮ್ಮ ಪರಿಶೀಲನೆ ಕೋಡ್ ಆಗಿದೆ.", withSecurity: "{{1}} ನಿಮ್ಮ ಪರಿಶೀಲನೆ ಕೋಡ್ ಆಗಿದೆ. ನಿಮ್ಮ ಭದ್ರತೆಗಾಗಿ, ಈ ಕೋಡ್ ಅನ್ನು ಹಂಚಿಕೊಳ್ಳಬೇಡಿ." },

  rw_RW: { default: "{{1}} ni kode yo kwemeza yawe.", withSecurity: "{{1}} ni kode y'igenzura yawe. Ku bw'umutekano wawe, ntusangize iyi kode." },

  ko: { default: "인증 코드는 {{1}}입니다.", withSecurity: "인증 코드는 {{1}}입니다. 보안을 위해 이 코드는 공유하지 마세요." },

  ky_KG: { default: "{{1}} — ырастоо кодуңуз.", withSecurity: "{{1}} — ырастоо кодуңуз. Коопсуздугуңуз үчүн бул кодду эч кимге бербеңиз." },

  lo: { default: "{{1}} ແມ່ນລະຫັດຢືນຢັນຂອງທ່ານ.", withSecurity: "{{1}} ແມ່ນລະຫັດຢືນຢັນຂອງທ່ານ. ສຳລັບຄວາມປອດໄພຂອງທ່ານ, ຢ່າແບ່ງປັນລະຫັດນີ້." },

  lv: { default: "{{1}} ir jūsu verifikācijas kods.", withSecurity: "{{1}} ir jūsu verifikācijas kods. Jūsu drošībai nekopīgojiet šo kodu." },

  lt: { default: "{{1}} yra jūsų patvirtinimo kodas.", withSecurity: "{{1}} yra jūsų patvirtinimo kodas. Saugos sumetimais nebendrinkite šio kodo." },

  mk: { default: "{{1}} е твојот код за верификација.", withSecurity: "{{1}} е твојот код за верификација. За твоја безбедност, не го споделувај овој код." },

  ms: { default: "{{1}} adalah kod penentusahan anda.", withSecurity: "{{1}} adalah kod penentusahan anda. Untuk keselamatan anda, jangan kongsikan kod ini." },

  ml: { default: "നിങ്ങളുടെ വെരിഫിക്കേഷൻ കോഡ് {{1}} ആണ്.", withSecurity: "നിങ്ങളുടെ വെരിഫിക്കേഷൻ കോഡ് {{1}} ആണ്. നിങ്ങളുടെ സുരക്ഷയ്‌ക്ക്, ഈ കോഡ് പങ്കിടരുത്." },

  mr: { default: "{{1}} हा तुमचा व्हेरिफिकेशन कोड आहे.", withSecurity: "{{1}} हा तुमचा व्हेरिफिकेशन कोड आहे. तुमच्या सुरक्षेसाठी हा कोड शेअर करू नका." },

  nb: { default: "{{1}} er verifiseringskoden din.", withSecurity: "{{1}} er verifiseringskoden din. Av hensyn til sikkerheten din må du ikke dele denne koden." },

  ps_AF: { default: "‎{{1}} is your verification code.‎", withSecurity: "‎{{1}} is your verification code. For your security, do not share this code.‎" },

  fa: { default: "‏{{1}}‏ کد درستی‌سنجی شما است.", withSecurity: "‏{{1}}‏ کد درستی‌سنجی شما است. برای حفظ امنیتتان این کد را به‌اشتراک نگذارید." },

  pl: { default: "{{1}} to kod weryfikacyjny.", withSecurity: "{{1}} to kod weryfikacyjny. Ze względów bezpieczeństwa nie udostępniaj tego kodu." },

  pt_BR: { default: "Seu código de verificação é {{1}}.", withSecurity: "Seu código de verificação é {{1}}. Para sua segurança, não o compartilhe." },
  pt_PT: { default: "{{1}} é o seu código de verificação.", withSecurity: "{{1}} é o seu código de verificação. Para sua segurança, não partilhe este código." },

  pa: { default: "ਤੁਹਾਡਾ ਤਸਦੀਕ ਕੋਡ {{1}} ਹੈ।", withSecurity: "ਤੁਹਾਡਾ ਤਸਦੀਕ ਕੋਡ {{1}} ਹੈ। ਆਪਣੀ ਸੁਰੱਖਿਆ ਦੇ ਲਈ, ਇਹ ਕੋਡ ਕਿਸੇ ਨਾਲ ਵੀ ਸਾਂਝਾ ਨਾ ਕਰੋ।" },

  ro: { default: "{{1}} este codul dvs. de verificare.", withSecurity: "{{1}} este codul de verificare. Pentru siguranţa dvs., nu dezvăluiţi acest cod." },

  ru: { default: "Ваш код подтверждения — {{1}}.", withSecurity: "Ваш код подтверждения — {{1}}. Из соображений безопасности не сообщайте никому этот код." },

  sr: { default: "{{1}} је ваш кôд за потврду.", withSecurity: "{{1}} је ваш кôд за потврду. Ради сопствене безбедности, немојте га делити ни са ким." },

  si_LK: { default: "{{1}} යනු ඔබේ සත්‍යාපන කේතය ‍වේ.", withSecurity: "{{1}} යනු ඔ‍බේ සත්‍යාපන කේතය ‍වේ. ඔ‍බේ ආරක්ෂාව සඳහා, මෙම කේතය බෙදා නොගන්න." },

  sk: { default: "Váš overovací kód je {{1}}.", withSecurity: "Váš overovací kód je {{1}}. V záujme vašej bezpečnosti tento kód s nikým nezdieľajte." },

  sl: { default: "Vaša potrditvena koda je {{1}}.", withSecurity: "Vaša potrditvena koda je {{1}}. Zaradi varnosti je ne delite." },

  es: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_AR: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_CL: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_CO: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_CR: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_DO: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_EC: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_HN: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_MX: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_PA: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_PE: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_ES: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },
  es_UY: { default: "Tu código de verificación es {{1}}.", withSecurity: "Tu código de verificación es {{1}}. Por tu seguridad, no lo compartas." },

  sw: { default: "{{1}} ndio msimbo wako wa uthibitishaji.", withSecurity: "{{1}} ndio msimbo wako wa uthibitishaji. Kwa usalama wako, usiushiriki." },

  sv: { default: "{{1}} är din verifieringskod.", withSecurity: "{{1}} är din verifieringskod. Av säkerhetsskäl ska du inte dela koden med någon annan." },

  ta: { default: "{{1}} என்பது சரிபார்ப்புக் குறியீடாகும்.", withSecurity: "{{1}} என்பது உங்கள் சரிபார்ப்புக் குறியீடாகும். பாதுகாப்பு நோக்கங்களுக்காக, இந்தக் குறியீட்டைப் பகிர வேண்டாம் என்று கேட்டுக் கொள்கிறோம்." },

  te: { default: "{{1}} మీ వెరిఫికేషన్ కోడ్.", withSecurity: "{{1}} మీ వెరిఫికేషన్ కోడ్. మీ భద్రత కోసం ఈ కోడ్‌ను షేర్ చేయవద్దు." },

  th: { default: "รหัสตรวจสอบยืนยันของคุณคือ {{1}}", withSecurity: "รหัสตรวจสอบยืนยันของคุณคือ {{1}} โปรดอย่าบอกรหัสนี้แก่ผู้อื่นเพื่อรักษาความปลอดภัยของคุณ" },

  tr: { default: "Doğrulama kodunuz: {{1}}.", withSecurity: "Doğrulama kodunuz: {{1}}. Güvenliğiniz için bu kodu paylaşmayın." },

  uk: { default: "Ваш код підтвердження – {{1}}.", withSecurity: "Ваш код підтвердження – {{1}}. З міркувань безпеки не повідомляйте нікому цей код." },

  ur: { default: "{1}}‏ آپ کا توثیقی کوڈ ہے۔", withSecurity: "‏{{1}}‏ آپ کا توثیقی کوڈ ہے۔ اپنی حفاظت کی خاطر یہ کوڈ شیئر نہ کریں۔" },

  uz: { default: "{{1}} – tasdiqlash kodingiz.", withSecurity: "{{1}} – tasdiqlash kodingiz. Xavfsizlik maqsadida bu kodni hech kimga yubormang." },

  vi: { default: "{{1}} là mã xác minh của bạn.", withSecurity: "{{1}} là mã xác minh của bạn. Để bảo mật, bạn đừng chia sẻ mã này." },

  zu: { default: "Okuthi {{1}} kuyikhodi yakho yokuqinisekisa.", withSecurity: "Okuthi {{1}} kuyikhodi yakho yokuqinisekisa. Ukuze uthole ukuvikeleka, ungayithumeleli muntu le khodi." },
};



export const EXPIRES_IN_TRANSLATIONS :Record<string, string>= {
  en: "Expires in {{1}} minutes.",
  en_GB: "Expires in {{1}} minutes.",
  en_US: "Expires in {{1}} minutes.",
  en_AE: "Expires in {{1}} minutes.",
  en_AU: "Expires in {{1}} minutes.",
  en_CA: "Expires in {{1}} minutes.",
  en_GH: "Expires in {{1}} minutes.",
  en_IE: "Expires in {{1}} minutes.",
  en_IN: "Expires in {{1}} minutes.",
  en_JM: "Expires in {{1}} minutes.",
  en_MY: "Expires in {{1}} minutes.",
  en_NZ: "Expires in {{1}} minutes.",
  en_QA: "Expires in {{1}} minutes.",
  en_SG: "Expires in {{1}} minutes.",
  en_UG: "Expires in {{1}} minutes.",
  en_ZA: "Expires in {{1}} minutes.",

  af: "Verval oor {{1}} minute.",
  sq: "Skadon pas {{1}} minutash.",

  ar: "تنتهي صلاحيتها خلال ‏{{1}}‏ دقائق.",
  ar_EG: "تنتهي صلاحيتها خلال ‏{{1}}‏ دقائق.",
  ar_AE: "تنتهي صلاحيتها خلال ‏{{1}}‏ دقائق.",
  ar_LB: "تنتهي صلاحيتها خلال ‏{{1}}‏ دقائق.",
  ar_MA: "تنتهي صلاحيتها خلال ‏{{1}}‏ دقائق.",
  ar_QA: "تنتهي صلاحيتها خلال ‏{{1}}‏ دقائق.",

  az: "{{1}} dəqiqə sonra vaxtı bitir",
  be_BY: "Expires in {{1}} minutes.",

  bn: "Expires in {{1}} minutes.",
  bn_IN: "{{1}} মিনিটের মধ্যে মেয়াদ শেষ হয়ে যাবে।",

  bg: "Изтича след {{1}} минути.",
  ca: "Caduca d'aquí a {{1}} minuts.",

  zh_CN: "于 {{1}} 分钟后过期。",
  zh_HK: "{{1}} 分鐘後過期。",
  zh_TW: "{{1}} 分鐘後過期。",

  hr: "Istječe za {{1}} min.",
  cs: "Platnost skončí za {{1}} minut.",
  da: "Udløber om {{1}} minutter.",

  prs_AF: "Expires in {{1}} minutes.",

  nl: "Verloopt over {{1}} minuten.",
  nl_BE: "Verloopt over {{1}} minuten.",

  et: "Aegub {{1}} minuti pärast.",
  fil: "Mag-e-expire sa loob ng {{1}} minuto.",
  fi: "Vanhentuu {{1}} minuutin kuluttua.",

  fr: "Expire dans {{1}} minutes.",
  fr_BE: "Expire dans {{1}} minutes.",
  fr_CA: "Expire dans {{1}} minutes.",
  fr_CH: "Expire dans {{1}} minutes.",
  fr_CI: "Expire dans {{1}} minutes.",
  fr_MA: "Expire dans {{1}} minutes.",

  ka: "Expires in {{1}} minutes.",

  de: "Läuft in {{1}} Minuten ab",
  de_AT: "Läuft in {{1}} Minuten ab",
  de_CH: "Läuft in {{1}} Minuten ab",

  el: "Λήγει σε {{1}} λεπτά.",

  gu: "{{1}} મિનિટમાં સમય પૂરો થશે.",

  ha: "Wa'adinta zai ƙare nan da mintuna {{1}}.",

  he: "התוקף יפוג בעוד ‏{{1}}‏ דקות.",

  hi: "{{1}} मिनट में समय-सीमा समाप्त हो जाएगी.",

  hu: "{{1}} perc múlva lejár.",

  id: "Kedaluwarsa dalam {{1}} menit.",

  ga: "Rachaidh sé as feidhm i gceann {{1}} nóiméad.",

  it: "Scade tra {{1}} minuti.",

  ja: "{{1}}分後に期限切れになります。",

  kn: "{{1}} ನಿಮಿಷಗಳಲ್ಲಿ ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತದೆ.",

  kk: "Мерзімі {{1}} минуттан кейін аяқталады.",

  rw_RW: "Expires in {{1}} minutes.",

  ko: "{{1}}분 후에 만료됩니다.",

  ky_KG: "Expires in {{1}} minutes.",

  lo: "ໝົດອາຍຸໃນ {{1}} ນາທີ.",

  lv: "Derīgums beigsies pēc {{1}} minūtēm.",

  lt: "Baigs galioti po {{1}} min.",

  mk: "Истекува за {{1}} минути.",

  ms: "Tamat tempoh dalam {{1}} minit.",

  ml: "{{1}} മിനിറ്റിൽ കാലഹരണപ്പെടുന്നു.",

  mr: "{{1}} मिनिटांमध्ये एक्स्पायर होईल.",

  nb: "Utløper om {{1}} minutter.",

  ps_AF: "‎Expires in {{1}} minutes.‎",

  fa: "‫‏{{1}}‏ دقیقه دیگر منقضی می‌شود.",

  pl: "Wygasa za {{1}} minut.",

  pt_BR: "Expira em {{1}} minutos.",
  pt_PT: "Expira dentro de {{1}} minutos.",

  pa: "ਮਿਆਦ {{1}} ਮਿੰਟਾਂ ਵਿੱਚ ਸਮਾਪਤ ਹੋ ਜਾਵੇਗੀ।",

  ro: "Expiră peste {{1}} minute.",

  ru: "Истекает через {{1}} мин.",

  sr: "Истиче за {{1}} минута.",

  si_LK: "Expires in {{1}} minutes.",

  sk: "Vyprší o {{1}} min.",

  sl: "Poteče čez {{1}} min.",

  es: "Vence en {{1}} minutos.",
  es_AR: "Vence en {{1}} minutos.",
  es_CL: "Vence en {{1}} minutos.",
  es_CO: "Vence en {{1}} minutos.",
  es_CR: "Vence en {{1}} minutos",
  es_DO: "Vence en {{1}} minutos",
  es_EC: "Vence en {{1}} minutos",
  es_HN: "Vence en {{1}} minutos",
  es_MX: "Vence en {{1}} minutos.",
  es_PA: "Vence en {{1}} minutos.",
  es_PE: "Vence en {{1}} minutos.",
  es_ES: "Vence en {{1}} minutos.",
  es_UY: "Vence en {{1}} minutos.",

  sw: "Muda wake utaisha baada ya dakika {{1}}.",

  sv: "Går ut om {{1}} minuter.",

  ta: "{{1}} நிமிடங்களில் காலாவதியாகும்.",

  te: "{{1}} నిమిషాల్లో గడువు ముగుస్తుంది.",

  th: "จะหมดอายุในอีก {{1}} นาที",

  tr: "Süresi {{1}} dakika sonra doluyor.",

  uk: "Термін дії завершується за {{1}} хв.",

  ur: "‫‏‫‏‏‫‏‏{{1}}‏ منٹ میں میعاد ختم ہو جائے گی۔",

  uz: "{{1}} daqiqadan keyin muddati tugaydi.",

  vi: "Hết hạn sau {{1}} phút.",

  zu: "Expires in {{1}} minutes.",
}